// https://en.wikipedia.org/wiki/UTM_parameters
// Called on App componentDidMount (every page load)
// Filter url params for any UTM-related params and store as cookie to pass to
// backend via sign up API

import includes from 'lodash/includes'
import reduce from 'lodash/reduce'
import isEmpty from 'lodash/isEmpty'
import Cookies from 'js-cookie'

const UTM_PARAMS = [
  'utm_campaign',
  'utm_source',
  'utm_medium'
]

const utm = ( ) => {
  const queryString = document.location.search.slice(1)
  if (!includes(queryString, 'utm_'))
    return

  const queries = queryString.split('&')
  let utmQueries = reduce(queries, (utmValues, query) => {
    let [param, value] = query.split('=')
    if (includes(UTM_PARAMS, param))
      utmValues[param] = value

    return utmValues
  }, { 'utm_params': queryString })


  if (!isEmpty(utmQueries)) {
    Cookies.set('utm', JSON.stringify(utmQueries), { expires: 60, path: '' })
  }
}

export default utm;
